module.exports = flarum.core.compat['components/Post'];